var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChessboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 2H3.25c-.332 0-.65.132-.883.367S2 2.918 2 3.25v17.5c0 .332.132.65.367.883S2.92 22 3.25 22h17.5c.332 0 .65-.132.883-.367S22 21.08 22 20.75V3.25c0-.332-.132-.65-.367-.883S21.082 2 20.75 2zm-.625 18.125H3.875V3.875h16.25v16.25zm-1.25-1.25v-3.437h-3.437v3.438h3.438zm0-6.875V8.563h-3.437V12h3.438zM5.125 5.125v3.438h3.438V5.125H5.125zm10.313 0H12v3.438h3.438V5.125zm-6.875 13.75H12v-3.437H8.563v3.438zM12 8.563H8.563V12H12V8.563zm0 6.875h3.438V12H12v3.438zM8.563 12H5.125v3.438h3.438V12z",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessboard);
export default __webpack_public_path__ + "static/media/chessboard.a22dd083d1f3bff857c9dba360d673ea.svg";
export { ForwardRef as ReactComponent };